import { h, Component } from 'preact';
import Store from 'store/store';
import { loadPage } from 'utils/pageComponents';
import { IntentDetector } from 'utils/intentDetector';

// Used for server-side rendering
const PLACEHOLDER_DOMAIN = 'https://placeholder/';

// Temporary
const STATIC = typeof window !== 'undefined' && new URLSearchParams(location.search).has('static');

export default class PageLink extends Component {

	constructor(props) {
		super(props);
		this.intentDetector = new IntentDetector({
			getBaseEvent: (name) => this.props[name],
			onIntent: this.onIntent.bind(this),
		});
	}

	componentWillUnmount() {
		this.intentDetector.dispose();
	}

	onIntent() {
		loadPage(this.props.to);
	}

	getLink(page = this.props.to, query = this.props.query) {
		const [pageName, anchor] = page.split('#');

		let base = PLACEHOLDER_DOMAIN;
		// let locationSafe = {};
		if (typeof window !== 'undefined') {
			base = window.__BASE_URL__ || PLACEHOLDER_DOMAIN;
			// locationSafe = location;
		}

		const pagePath = Store.get().appData.pages[pageName]?.path || '';
		let url = new URL('.' + pagePath, base);

		// Cannot preserve the current search params as it would break the leadership navigation by not closing the leader (keeps ?name)
		//     (unless we make sure to empty it in some way - what is the cleanest solution here ? A list of query string items always cleared ?)
		// url.search = locationSafe.search || '';
		if (STATIC) url.searchParams.set('static', '1');
		if (query) {
			Object.entries(query).forEach(entry => url.searchParams.set(...entry));
		}
		// url.hash = anchor || locationSafe.hash || '';
		if (anchor) url.hash = anchor;

		return url.href.replace(PLACEHOLDER_DOMAIN, '/');
	}

	render({ to, children, ...props }) {
		return (
			<a
				href={this.getLink()}
				{...props}
				{...this.intentDetector.events}
			>
				{children}
			</a>
		);
	}

}